import { call, put, takeEvery } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import { GET_FABRIC_RESOURCE } from "./actionTypes"

//Include Both Helper File with needed methods
import { getFabricResourceAPI } from "helpers/fabric_resource"

import { getFabricResourceSuccess, getFabricResourceError } from "./actions"
import debounce from "debounce-promise"

const debouncegetFabricAPI = debounce(getFabricResourceAPI, 1000)

function* fetchFabric(args) {
  let params = args.payload
  yield put(getFabricResourceSuccess({ status: "process", data: {} }))
  try {
    let { data } = yield call(debouncegetFabricAPI, params)
    yield put(getFabricResourceSuccess({ status: "success", data }))
  } catch (error) {
    yield put(getFabricResourceError(error?.response))
  }
}

function* fabricSaga() {
  yield takeEvery(GET_FABRIC_RESOURCE, fetchFabric)
}

export default fabricSaga
